const PAYMENT_TYPE = {
  HAND_PAYMENT_TYPE: 'Manual',
  EZ_PAYMENT_TYPE: 'Enzona',
  TM_PAYMENT_TYPE: 'Transfermóvil',
};
/**
 * Enum definition.
 *
 * @type {string[]}
 */
const PAYMENT_TYPE_ENUM = Object.keys(PAYMENT_TYPE);

const HAND_PAYMENT_TYPE = PAYMENT_TYPE_ENUM[0];
const EZ_PAYMENT_TYPE = PAYMENT_TYPE_ENUM[1];
const TM_PAYMENT_TYPE = PAYMENT_TYPE_ENUM[2];

export {
  PAYMENT_TYPE_ENUM,
  PAYMENT_TYPE,
  HAND_PAYMENT_TYPE,
  EZ_PAYMENT_TYPE,
  TM_PAYMENT_TYPE,
};
